export const PAGINATION_NUMBER = 15;

export const TRACKER_FIRMWARES: string[] = [
  'kid1',
  'cat1',
  'pet1',
  'kid2',
  'kid3',
  'pet3',
  'cat3',
  'animal',
  'family'
];

export const WHITE_LABEL_BRANDS: string[] = [
  'vini',
  'zolux',
  'maroc_telecom',
  'pdf',
  'pev',
  'trouville',
  'lecannet',
  'two_tails',
  'gabon_telecom',
  'frejus',
  'orange'
];

export const SOS_MODES: string[] = [
  'simple',
  'normal',
  'direct',
  'direct_simple',
  'partner',
  'direct_partner',
  'test',
  'full-sos',
];

export const TRACKER_TYPES: string[] = [
  'default',
  'kid',
  'cat',
  'cat2',
  'silver',
  'pet',
  'pet2',
  'sport',
  'pdfou',
  'skiset',
  'animal',
  'animalcat',
  'animaldog',
  'family',
  'familykid',
  'familysilver'
];

export const GEOFENCE_MODES: string[] = [
  'normal',
  'none',
  'proportionnal',
  'margin_0_50',
  'margin_5_50',
  'margin_10_50',
  'margin_15_50',
  'margin_20_50',
  'margin_25_50',
  'margin_30_50',
  'margin_35_50',
  'margin_40_50',
  'margin_45_50',
  'margin_50_50',
  'margin_55_50',
  'margin_60_50',
  'margin_65_50',
  'margin_70_50',
  'margin_75_50',
  'margin_80_50',
  'margin_85_50',
  'margin_90_50',
  'margin_95_50',
  'margin_100_50',
  'margin_105_50',
  'margin_110_50',
  'margin_115_50',
  'margin_120_50',
  'margin_125_50',
  'margin_130_50',
  'margin_135_50',
  'margin_140_50',
  'margin_145_50',
  'margin_0_25',
  'margin_5_25',
  'margin_10_25',
  'margin_15_25',
  'margin_20_25',
  'margin_25_25',
  'margin_30_25',
  'margin_35_25',
  'margin_40_25',
  'margin_45_25',
  'margin_50_25',
  'margin_55_25',
  'margin_60_25',
  'margin_65_25',
  'margin_70_25',
  'margin_75_25',
  'margin_80_25',
  'margin_85_25',
  'margin_90_25',
  'margin_95_25',
  'margin_100_25',
  'margin_105_25',
  'margin_110_25',
  'margin_115_25',
  'margin_120_25',
  'margin_125_25',
  'margin_130_25',
  'margin_135_25',
  'margin_140_25',
  'margin_145_25',
  'margin_150_25',
  'margin_5_0',
  'margin_10_0',
  'margin_15_0',
  'margin_20_0',
  'margin_25_0',
  'margin_30_0',
  'margin_35_0',
  'margin_40_0',
  'margin_45_0',
  'margin_50_0',
  'margin_55_0',
  'margin_60_0',
  'margin_65_0',
  'margin_70_0',
  'margin_75_0',
  'margin_80_0',
  'margin_85_0',
  'margin_90_0',
  'margin_95_0',
  'margin_100_0',
  'margin_105_0',
  'margin_110_0',
  'margin_115_0',
  'margin_120_0',
  'margin_125_0',
  'margin_130_0',
  'margin_135_0',
  'margin_140_0',
  'margin_145_0',
  'margin_150_0'
];

export const TRACKER_MODES: string[] = [
  'smart',
  'live',
  'sleep'
];

export const TRACKER_SENSOR_MODES: string[] = [
  'normal',
  'deep'
];



// WEBPACK FOOTER //
// /app/src/app/services/constants.service.ts